<template>
  <nav v-if="isMobile" class="bottom-nav">
    <div class="bottom-nav-container">
      <!-- Dashboard -->
      <RouterLink to="/admin" class="bottom-nav-item" :class="{ active: isActive('dashboard') }">
        <VaIcon name="vuestic-iconset-dashboard" size="24px" class="nav-icon" />
        <span class="nav-label">Tableau</span>
      </RouterLink>

      <!-- Budget -->
      <RouterLink to="/budget-workbench" class="bottom-nav-item" :class="{ active: isActive('budget-workbench') }">
        <VaIcon name="account_balance_wallet" size="24px" class="nav-icon" />
        <span class="nav-label">Budget</span>
      </RouterLink>

      <!-- Transactions -->
      <RouterLink to="/transactions" class="bottom-nav-item" :class="{ active: isActive('transactions') }">
        <VaIcon name="receipt_long" size="24px" class="nav-icon" />
        <span class="nav-label">Mouvements</span>
      </RouterLink>

      <!-- Reports -->
      <RouterLink to="/reports" class="bottom-nav-item" :class="{ active: isActive('reports') }">
        <VaIcon name="assessment" size="24px" class="nav-icon" />
        <span class="nav-label">Rapports</span>
      </RouterLink>

      <!-- Users (Admin only) -->
      <RouterLink v-if="isAdminUser" to="/users" class="bottom-nav-item" :class="{ active: isActive('users') }">
        <VaIcon name="group" size="24px" class="nav-icon" />
        <span class="nav-label">Utilisateurs</span>
      </RouterLink>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useBreakpoint } from 'vuestic-ui'
import { useAuthStore } from '../../stores/auth'

const route = useRoute()
const breakpoints = useBreakpoint()
const authStore = useAuthStore()

const isMobile = computed(() => breakpoints.smDown)

const isAdminUser = computed(() => {
  const user = authStore.user as any
  return (
    user?.is_superuser === true ||
    user?.is_superuser === 'true' ||
    user?.is_staff === true ||
    user?.is_staff === 'true' ||
    user?.username === 'Admin'
  )
})

const isActive = (routeName: string) => {
  return route.name === routeName
}
</script>

<style scoped lang="scss">
/* ============================================================
   BOTTOM NAVIGATION
   ============================================================ */

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 40;
  background: #fff;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -4px 12px rgba(15, 23, 42, 0.08);
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
}

.bottom-nav-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 64px;
  max-width: 100%;
  padding: 0.5rem 0;
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.5rem 0.75rem;
  min-width: 64px;
  height: 56px;
  border-radius: 8px;
  color: #64748b;
  text-decoration: none;
  transition: all 0.2s ease;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif;

  &:active {
    background: rgba(29, 78, 216, 0.08);
  }

  &.active {
    color: #1d4ed8;
    background: rgba(29, 78, 216, 0.1);
  }
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.nav-label {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: center;
  line-height: 1;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
}

.bottom-nav-item.active {
  .nav-icon {
    transform: scale(1.1);
  }

  .nav-label {
    font-weight: 800;
  }
}

/* ============================================================
   RESPONSIVE
   ============================================================ */

@media (max-width: 640px) {
  .bottom-nav-container {
    height: 62px;
    padding: 0.4rem 0;
  }

  .bottom-nav-item {
    gap: 0.3rem;
    padding: 0.4rem 0.6rem;
    min-width: 56px;
    height: 52px;
  }

  .nav-label {
    font-size: 0.62rem;
  }
}

@media (max-width: 380px) {
  .bottom-nav-container {
    height: 58px;
    padding: 0.3rem 0;
  }

  .bottom-nav-item {
    gap: 0.25rem;
    padding: 0.3rem 0.5rem;
    min-width: 50px;
    height: 48px;
  }

  .nav-label {
    font-size: 0.58rem;
  }

  .bottom-nav-item :deep(.va-icon) {
    font-size: 20px !important;
  }
}
</style>
